module.exports = __webpack_public_path__ + "img/bucket_parked.2bf0da44.svg";